import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ImageBase } from '@/types/image'

export const useBackgroundStore = defineStore('backgroundStore', () => {
  const uploadedBackgroundPreview = ref<ImageBase | undefined>()
  function setUploadedBackgroundPreview(preview: ImageBase | undefined) {
    uploadedBackgroundPreview.value = preview
  }

  const generatedBackground = ref<ImageBase | undefined>()
  function setGeneratedBackground(preview: ImageBase | undefined) {
    generatedBackground.value = preview
  }

  function dispose() {
    uploadedBackgroundPreview.value = undefined
    generatedBackground.value = undefined
  }

  return {
    uploadedBackgroundPreview,
    setUploadedBackgroundPreview,
    generatedBackground,
    setGeneratedBackground,
    dispose,
  }
})
